import '../../assets/index.less'

const AgreementRegister = () => {
  document.title = '用户注册协议'
  return (
    <div className="page agreement">
      <div className="main">
        <img className="logo" src={require('../../assets/logo.png')} alt="" />
        <div className="h1">用户注册协议</div>
        <div className="p">版本更新日期：2022年6月20日</div>
        <div className="p">版本生效日期：2022年6月20日</div>

        <div className="h3">一、服务条款的确认及接受</div>
        <div className="p">
          1、元萝卜AI下棋机器人（以下简称元萝卜）微信小程序中的各项电子服务的所有权和运作权归属于上海商汤数字科技有限公司（以下简称商汤）所有，本软件提供的服务将完全按照其发布的服务条款和操作规则严格执行。您确认所有服务条款并完成注册程序时，本协议在您与本软件间成立并发生法律效力，同时您成为本软件正式用户。
        </div>
        <div className="p">
          2、根据国家法律法规变化及本软件运营需要，商汤有权对本协议条款及相关规则不时地进行修改，修改后的内容一旦以任何形式公布在本软件上即生效，并取代此前相关内容，您应不时关注本软件公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用本软件；如您继续使用本软件，即视为知悉变动内容并同意接受。
        </div>
        <div className="p">
          3、请您务必审慎阅读、充分理解各条款内容，特别是涉及您重大权益的条款，特别是免除或者限制商汤责任的条款、限制用户权利的条款、约定争议解决方式和司法管辖的条款等，以及开通或使用某项服务的单独协议或规则（如有）。前述条款可能以加粗、加下划线等形式提示您注意。您点击“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。如对注册协议内容有任何疑问、意见或建议，您可通过senserobot@sensetime.com与我们联系。
        </div>
        <div className="p">
          4、本协议下我们推定您为具备完全民事权利能力和与所从事的民事行为相适应的行为能力的中华人民共和国大陆地区法律实体，且并非任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象（“受限对象”）。如果您因年龄、智力等因素而不具有完全民事行为能力，请在监护人的陪同下阅读和同意本协议。
        </div>
        <div className="p">
          5、如果您是中国大陆地区以外的用户，您订立或履行本协议的行为需要同时遵守您所属国家或地区的法律。您应保证，您订立并履行本协议的行为不违反您所属的国家或地区法律法规的强制性规定。若您并非前述适格主体（或未取得监护人同意）但仍继续签署本协议的，商汤有权在获知相关情况后拒绝或终止向您提供服务，您（及您的监护人）须自行承担相关损失。
        </div>
        <div className="p">6、您与商汤在本协议中单独一方会被称作一方，共同被称作双方。</div>
        <div className="h3">二、服务须知</div>
        <div className="p">
          1、本软件运用微信小程序平台为用户提供设备联网绑定、棋手登录、评测报名等服务。使用本软件，您需要：
        </div>
        <div className="p">（1）自行购买元萝卜旗下智能硬件产品；</div>
        <div className="p">（2）自行负担个人上网所支付的与此服务有关的电话费用、网络费用等；</div>
        <div className="p">
          （3）评测考证服务为单独购买选项，您具有自主选择权，可以选择其他类似服务提供者，可以选择不继续购买评测考证服务，经您确认同意后方视为购买成功。如您因各类原因无法进行评测，您有权申请退款，商汤收到申请并审核通过后将无息退还您支付的评测服务费。请知悉一旦您开始进行评测，您所支付的评测服务费将无法进行退款。
        </div>
        <div className="p">2、基于本软件所提供的网络服务的重要性，您确认并同意：</div>
        <div className="p">
          （1）为访问与使用本服务，您必须注册一个平台账号才能使用服务。为此，您须按照注册页面提示填写相关注册资料（包括您合法所有、已实名的手机号码等），并自行设定密码。提供的注册资料真实、准确、完整、合法有效，注册资料如有变动的，应及时更新。账号的所有权归商汤所有。
        </div>
        <div className="p">
          （2）如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且商汤保留终止您使用本软件各项服务的权利。
        </div>
        <div className="p">
          3、您确保在申请使用本服务前已满足使用本服务的全部条件与要求，否则商汤可拒绝或随时终止服务，且因您不满足使用条件导致商汤无法提供本服务的，商汤不承担法律明确规定以外的任何责任，您应自行承担相关损失。
        </div>
        <div className="h3">三、用户个人信息保护及授权</div>
        <div className="p">
          1、您知悉并同意，为方便您使用本软件相关服务，本软件将存储您在使用时的必要信息，包括但不限于您的真实姓名、性别、生日、身份证、人脸信息、联系方式等。除法律法规规定的情形外，未经您的许可商汤不会向第三方公开、透露您的个人信息。商汤对相关信息采取专业加密存储与传输方式，利用合理措施保障用户个人信息的安全。我们非常重视和保护您的个人信息，制定了《隐私政策》、《人脸识别服务协议》等相关协议、政策及规则，在您使用我们提供的产品和服务前，请您务必进行阅读。
        </div>
        <div className="p">
          2、您知悉并确认，您在注册帐号或使用本软件服务的过程中，商汤可能要求您进行实名认证。为完成实名认证，您需按照本平台页面提示填写、提交真实、合法、有效的身份信息（统称“资料”）。前述资料包括但不限于您的姓名、电子邮箱、联系电话、联系地址等；如果资料发生变更的，您应及时根据本平台相关页面提示的规则自行进行更新。商汤将根据国家法律法规相关要求，进行基于移动电话号码的真实身份信息认证。若您提供的信息不真实、不完整，则无法使用本软件或在使用过程中受到限制，同时，由此产生的不利后果，由您自行承担。此外，您应了解并同意，商汤有权根据业务需要随时调整资料提交要求及/或出于抽查之需要等要求您补充提交相关信息资料，您应予配合。您同意授权商汤可以通过向第三方核实您的身份和资格等信息的方式，对您进行认证及取得您的相关资料。
        </div>
        <div className="p">
          3、实名认证是对您的身份进行判断的一个依据，与您使用本软件中各项服务直接相关，请您在做认证时务必谨慎对待，给予足够的重视并理解、遵守以下规则：
        </div>
        <div className="p">
          （1）您须确保您已获得充分授权并有权代表相关签署及履行本协议，申请、使用本软件下各项服务；
        </div>
        <div className="p">
          （2）您为进行实名认证或组织管理而提交其他主体信息资料时，应确保已取得相关主体的明示同意；
        </div>
        <div className="p">
          （3）您须确保认证主体与账号及实际服务使用主体保持一致，避免将账号认证在他人名下等任何不当认证行为；
        </div>
        <div className="p">
          （4）您应始终谨慎知悉，实名认证主体将被视为承诺对账号下的一切行为负责，因此，您在申请或使用本服务时，请您务必保管好您的账户，并确保您所使用的账号为您自身合法持有且您享有完全的使用控制权。若账号或账号下行为出现纠纷时（包括但不限于实施违法违规行为等），需由实名认证主体承担全部责任。
        </div>
        <div className="p">
          4、您在使用本软件某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”），您在使用该项服务前请阅读并同意相关的单独协议；您使用前述特定服务，即视为您已阅读并同意接受相关单独协议。
        </div>
        <div className="p">5、您充分理解并同意：</div>
        <div className="p">（1）商汤通过微信、短信、电话等形式，向您发送优惠活动等内容；</div>
        <div className="p">
          （2）为配合行政监管机关、司法机关执行工作，在法律规定范围内商汤有权向上述行政、司法机关提供您在使用本软件时所储存的相关信息，包括但不限于您的注册信息等，或使用相关信息进行证据保全，包括但不限于公证、见证等；
        </div>
        <div className="p">
          （3）商汤依法保障您在安装或使用过程中的知情权和选择权，在您使用本软件服务过程中，涉及您设备自带功能的服务会提前征得您同意，您一经确认，商汤有权开启包括但不限于收集地理位置、读取通讯录、使用摄像头、启用录音等提供服务必要的辅助功能。（4）商汤有权根据实际情况，在法律规定范围内自行决定单个用户在本软件及服务中数据的最长储存期限以及用户日志的储存期限，并在服务器上为其分配数据最大存储空间等。
        </div>
        <div className="h3">四、用户行为规范</div>
        <div className="p">
          1、您同意严格遵守法律法规规章规定、公序良俗和信息真实性等基本原则，不利用本软件平台、本软件下各项服务制作、复制、发布、传输、传播任何违反法律法规、或侵犯其他用户或第三方合法权益的内容，包括但不限于：
        </div>
        <div className="p">
          （1）以下违法内容：反对宪法所确定的基本原则，煽动抗拒、破坏宪法和法律法规实施的；危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的，煽动推翻社会主义制度的；损害国家荣誉和利益的；歪曲、丑化、亵渎、否定英雄烈士事迹和精神，侵害英雄烈士的姓名、肖像、名誉、荣誉的；宣扬或煽动实施恐怖主义、极端主义及其活动的；煽动民族仇恨、民族歧视、破坏民族团结的言论；破坏国家宗教政策，宣扬邪教和封建迷信的；散布谣言，扰乱经济秩序和社会秩序的；散布淫秽、色情、暴力或者教唆犯罪的；侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；法律、行政法规禁止的其他内容。
        </div>
        <div className="p">
          （2）含有下列内容的不良信息：标题严重夸张，发表内容与标题严重不符的；不当评述自然灾害、重大事故等灾难的；煽动人群歧视、地域歧视等的；宣扬低俗、庸俗、媚俗内容的；违反社会公德行为的；侵犯未成年人合法权益的；其他对网络生态造成不良影响的内容。
        </div>
        <div className="p">（3）侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</div>
        <div className="p">（4）涉及他人隐私、个人信息或资料的；</div>
        <div className="p">（5）骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的；</div>
        <div className="p">
          （6）其他违反法律法规、政策及公序良俗、社会公德或干扰本软件服务正常运营和侵犯其他用户或第三方合法权益内容的信息。
        </div>
        <div className="p">2、本协议依据国家相关法律法规规章制定，您亦同意严格遵守以下义务：</div>
        <div className="p">（1）从中国大陆向境外传输资料信息时必须符合中国有关法规；</div>
        <div className="p">
          （2）不得利用本软件从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
        </div>
        <div className="p">（3）不得干扰本软件的正常运转，不得侵入本软件及国家计算机信息系统；</div>
        <div className="p">
          （4）不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、不文明的等信息资料；
        </div>
        <div className="p">（5）不得教唆他人从事违法违规或本协议、平台规则所禁止的行为；</div>
        <div className="p">（6）不得利用在本软件注册的账户进行牟利性经营活动；</div>
        <div className="p">
          （7）不得发布任何侵犯他人个人信息、著作权、商标权等知识产权或合法权利的内容；
        </div>
        <div className="p">
          3、您须对自己在网上的言论和行为承担法律责任，您若在本软件上散布和传播反动、色情或其它违反国家法律的信息，本软件的系统记录有可能作为您违反法律或本协议的相关证据。
        </div>
        <div className="h3">五、本软件使用规范</div>
        <div className="p">1、关于移动客户端软件的获取与更新：</div>
        <div className="p">
          （1）您可以直接从微信小程序平台获取“元萝卜AI下棋机器人”，如果您从未经商汤授权的第三方获取软件或与商汤软件名称相同的软件程序，商汤无法保证该软件能够正常使用，并对因此给您造成的损失不予负责；
        </div>
        <div className="p">
          （2）为了改善用户体验、完善服务内容，商汤将不断努力开发新的服务，并为您不时提供软件更新，新版本发布后，旧版本的软件可能无法使用，商汤不保证旧版本软件继续可用及相应的客户服务。
        </div>
        <div className="p">2、除非法律允许或商汤书面许可，您使用本软件过程中不得从事下列行为：</div>
        <div className="p">（1）删除本软件及其副本上关于著作权的信息；</div>
        <div className="p">
          （2）对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；
        </div>
        <div className="p">
          （3）对商汤拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；
        </div>
        <div className="p">
          （4）对本软件或者本软件运行过程中释放到任何终端内存中的数据、网站运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经商汤授权的第三方工具/服务接入本软件和相关系统；
        </div>
        <div className="p">
          （5）通过修改或伪造网站运行中的指令、数据，增加、删减、变动网站的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
        </div>
        <div className="p">
          （6）通过非商汤开发、授权的第三方软件、插件、外挂、系统，登录或使用本软件及服务，或制作、发布、传播上述工具；
        </div>
        <div className="p">
          （7）自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰。
        </div>
        <div className="p">
          （8）其他以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用“元萝卜AI下棋机器人”系统和/或本软件下各项产品或服务。
        </div>
        <div className="h3">六、违约责任</div>
        <div className="p">
          1、您充分了解并同意，您须为自己注册或认证的用户账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。同时，您应了解并同意，商汤无法对您的使用行为进行控制，但商汤有权拒绝为非法或侵权使用行为提供服务，因此，如商汤发现或收到您使用本软件服务的行为不符合法律法规规定或不符合本协议的投诉、举报等或存在恶意行为的，有权独立地对您的行为及适用的规则进行认定，并据此处理，包括警示、拒绝发布、删除信息、限制功能、暂停更新、中止服务、终止服务直至关闭账号、向有关监管部门或国家机关报告、要求您赔偿损失等，并公告处理结果以及保存相关记录。
        </div>
        <div className="p">
          2、商汤有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。
        </div>
        <div className="p">
          3、您理解并同意，因您违反法律规定和/或本协议约定和/或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任商汤因此遭受的全部损失，您也应当一并赔偿。
        </div>
        <div className="h3">七、免责条款</div>
        <div className="p">
          1、您理解并同意，“元萝卜AI下棋机器人”同大多数网站、互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响“元萝卜AI下棋机器人”的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失；同时，您承认和同意商汤并不能就“元萝卜AI下棋机器人”、软件安全或正常使用提供完全保证。
        </div>
        <div className="p">
          2、
          您理解并同意，您将自行承担使用“元萝卜AI下棋机器人”各服务的所有风险。商汤在此明确声明，不提供任何明示或默示的担保和保证，包括但不限于：
        </div>
        <div className="p">(1) 本服务将符合您的实际或特定需求或目的；</div>
        <div className="p">(2) 本服务的准确性、完整性或及时性；</div>
        <div className="p">(3) 本服务将不受干扰、无中断、持续稳定或没有错误；</div>
        <div className="p">(4) 使用本服务获得的任何结果或资料的正确性或可靠性；</div>
        <div className="p">(5) 本服务中的任何错误、问题、故障都将得到更正或解决；</div>
        <div className="p">(6) 经本服务购买或获得的任何产品、服务或其他内容符合您的期望；</div>
        <div className="p">
          (7) 本服务中第三方服务或外部链接及其指向的内容的准确性、稳定性和完整性；
        </div>
        <div className="p">(8) 您提供给商汤的信息不受任何侵害。</div>
        <div className="p">
          3、您明确理解并同意，商汤将不对由以下原因导致的直接、间接、偶然、特殊、继发性或惩罚性损失负责，包括但不仅限于利润、声誉、使用、数据方面的损失或其他无形损失：
        </div>
        <div className="p">
          (1) 您使用或无法使用“元萝卜AI下棋机器人”下的产品或服务（包括第三方产品或服务）；
        </div>
        <div className="p">
          (2)
          由于通过“元萝卜AI下棋机器人”获得任何商品、数据、信息或服务、接收讯息或参与交易而导致购买替代商品和服务的费用；
        </div>
        <div className="p">(3) 未经授权的访问或修改传输内容或数据；</div>
        <div className="p">
          (4)
          任何第三方有关“元萝卜AI下棋机器人”的声明或行为；或者与“元萝卜AI下棋机器人”有关的其他事宜。
        </div>
        <div className="p">
          4、您同意如发生不可抗力导致“元萝卜AI下棋机器人”的运行中断或终止时，商汤无需承担任何责任。本协议所指不可抗力包括：天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况。
        </div>
        <div className="p">
          5、您理解并同意，商汤可能会定期或不定期地对支撑其服务的“元萝卜AI下棋机器人”进行检修或者维护、或对相关合作第三方进行汰换，并可能因此造成一定时间的服务中断；商汤亦可能根据“元萝卜AI下棋机器人”运营情况，中止或终止本平台运营。就此等中断或终止，商汤将尽可能提前在相关网站、客户端内或服务相关页面内进行公告，或通过电子邮件、短信息等方式提前通知您；但除因商汤单方原因故意导致您损失的情况外，商汤不就此承担责任。
        </div>
        <div className="h3">八、所有权及知识产权</div>
        <div className="p">
          1、您一旦接受本协议，对于您提供、上传、创作、发布在本软件的文字、评论、图片、照片、视频、音频等任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等），您免费授予商汤及其关联公司至保护期终止为止、不可撤销的、全球范围的、非排他的许可使用著作权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可许可使用的权利）、肖像权、用户ID名称等相关的全部合法权利权益，就商汤具有诉讼主体资格的权利、权益，商汤有权以自身名义对第三方侵权行为取证及提起诉讼。您同意商汤及其关联公司有权存储、使用、复制、修订、编辑、发布、展示、翻译、分发、推广、出版、发行、信息网络传播您以上信息内容，有权改编制作派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。
        </div>
        <div className="p">2、商汤有权再许可给其他第三方第八条第一款的所有权利。</div>
        <div className="p">
          3、您应确保在商汤网站上发表的第八条第一款各类信息内容均不涉及侵犯第三方肖像、隐私、知识产权或其他合法权益，否则商汤有权随时采取包括但不限于删除、断开链接等措施。
        </div>
        <div className="p">
          4、本协议已经构成《中华人民共和国著作权法》第二十六条（条文序号依照2020年11月11日发布的《著作权法》确定）及相关法律规定的著作财产权等权利许可使用的书面协议，其效力及于您在本软件上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。
        </div>
        <div className="p">
          5、除法律另有强制性规定外，未经商汤明确的特别书面同意,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本软件的信息内容，否则，商汤有权追究其法律责任。
        </div>
        <div className="p">
          6、除另有特别声明外，商汤于本软件中提供的全部信息内容（包括但不限于单位形象、任何标识、软件、技术、程序、网页、文字、图片、音频、视频、图表、页面排版设计、API等）的知识产权均归商汤所有，依法属于他人所有的除外。除另有特别声明外，商汤提供本软件服务时所依托的“元萝卜AI下棋机器人”小程序的著作权、专利权及其他知识产权亦归商汤所有。上述及其他任何商汤依法拥有的知识产权均受到法律保护，未经商汤书面许可，您不得以任何形式进行使用或创造相关衍生作品。。
        </div>
        <div className="h3">九、法律管辖适用及其他</div>
        <div className="p">
          1、本协议的订立、执行和解释及争议的解决均应适用中国法律。如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，应向协议签订地有管辖权的人民法院提起诉讼。本协议签订地为中华人民共和国上海市徐汇区。
        </div>
        <div className="p">
          2、如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
        </div>
        <div className="p">
          3、本协议未明示授权的其他权利仍由商汤保留，您在行使这些权利时须另外取得商汤的书面许可。商汤如果未行使前述任何权利，并不构成对该权利的放弃。
        </div>
      </div>
    </div>
  )
}

export default AgreementRegister
